import {
	ChangeDetectionStrategy,
	Component,
	inject,
	signal,
} from '@angular/core';
import {
	FormControl,
	FormGroup,
	ReactiveFormsModule,
	Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { MessagesService } from '@pressteaze/ui';
import { AuthApiService } from './auth-api.service';

@Component({
	selector: 'lib-configuration-login',
	imports: [ReactiveFormsModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './configuration-login.component.html',
	styleUrl: 'configuration-login.component.css',
})
export class ConfigurationLoginComponent {
	private readonly api = inject(AuthApiService);
	private readonly router = inject(Router);
	private readonly messagesSrv = inject(MessagesService);
	readonly busy = signal(false);
	readonly form = new FormGroup({
		username: new FormControl('', {
			nonNullable: true,
			validators: [Validators.required],
		}),
		password: new FormControl('', {
			nonNullable: true,
			validators: [Validators.required],
		}),
	});

	async submit(): Promise<void> {
		if (this.form.invalid || this.busy()) return;
		this.busy.set(true);
		try {
			await this.api.configurationLogin(
				this.form.controls.username.value,
				this.form.controls.password.value,
			);
			this.messagesSrv.success('Συνδεθήκατε επιτυχώς');
			await this.router.navigateByUrl('/');
		} catch {
			this.messagesSrv.error(
				'Η σύνδεση απέτυχε',
				'Τα στοιχεία σύνδεσης δεν είναι σωστά.',
			);
		} finally {
			this.busy.set(false);
		}
	}
}
